import { useMedia } from './chunk-ZIBTY3GT.js';
import { $$_next_template, $$_create_template } from 'maverick.js/dom';
import { computed } from 'maverick.js';
import { defineElement, Component } from 'maverick.js/element';

var $$_templ = /* @__PURE__ */ $$_create_template(`<!$><svg part="icon" fill="none" viewBox="0 0 120 120" aria-hidden="true"><circle part="track" cx="60" cy="60" r="54" stroke="currentColor"></circle><circle part="track-fill" cx="60" cy="60" r="54" stroke="currentColor" pathLength="100"></circle></svg>`);
var BufferingIndicator = class extends Component {
  onAttach() {
    this.a = useMedia();
    this.setAttributes({
      "data-buffering": computed(this.ph.bind(this))
    });
  }
  ph() {
    const { canPlay, waiting } = this.a.$store;
    return !canPlay() || waiting();
  }
  render() {
    return $$_next_template($$_templ);
  }
};
BufferingIndicator.el = defineElement({
  tagName: "media-buffering-indicator"
});

export { BufferingIndicator };
